"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const ColonySpace_vue_1 = require("./ColonySpace.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'ColonyRow',
    components: {
        ColonySpace: ColonySpace_vue_1.default,
    },
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        colony: {
            type: Object,
            required: true,
        },
    },
});
